import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ActivitiesGlobalHandler } from 'component/common/Handler/ActivitiesGlobalHandler';
import { getBootstrapConfig } from 'core/window/windowService';
import { WhiteLabelThemeProvider } from 'app/WhiteLabelThemeProvider';
import { CartRootProvider } from 'component/common/CartContextSetup/CartContextSetup';
import { SessionPackageInitialization } from 'component/common/SessionPackageInitialization/SessionPackageInitialization';
import ActivitiesRoutes from 'app/ActivitiesRoutes';
import BootstrapConfigSetter from 'app/BootstrapConfigSetter';

/*
 * Vite splits bundles by file name.
 * Drone main and theme CSS are moved to different files to split bigger CSS into smaller chunks
 */
// TODO: Find ways to remove relative imports
/* eslint-disable import/order,no-restricted-imports */
import './drone-main.scss';
import './drone-theme.scss';
import './app.scss';
/* eslint-enable */

const VideoPlayerStyle: React.CSSProperties = { height: 'auto', width: '100%', maxHeight: '80vh', display: 'none' };

const AppComponent: React.FC = () => {
    const bootstrapConfig = getBootstrapConfig();

    return (
        <WhiteLabelThemeProvider whiteLabelId={bootstrapConfig.whiteLabelId}>
            <BootstrapConfigSetter config={bootstrapConfig} />
            <ActivitiesGlobalHandler config={bootstrapConfig} />
            <CartRootProvider>
                <React.Suspense fallback={null}>
                    <SessionPackageInitialization />
                </React.Suspense>
                <div className="Layout Layout__siteWrapper" data-element-name="layout-site-wrapper">
                    <React.Suspense fallback={null}>
                        <RouterProvider router={createBrowserRouter(ActivitiesRoutes(bootstrapConfig))} />
                    </React.Suspense>
                </div>
                <video id="Activity--MediaTypeTester" style={VideoPlayerStyle} src="">
                    <track src="" kind="captions" />
                </video>
            </CartRootProvider>
        </WhiteLabelThemeProvider>
    );
};
AppComponent.displayName = 'AppComponent';

export default AppComponent;
